module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="javascript:void(0)" class="js-load-more load-more-bt simple-button hidden">\n	Load more\n	<i class="ion-chevron-down" ></i>\n</a>';
}
return __p;
};
